import { render, staticRenderFns } from "./Iptv.vue?vue&type=template&id=4d3211a4&scoped=true&"
import script from "./Iptv.vue?vue&type=script&lang=js&"
export * from "./Iptv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3211a4",
  null
  
)

export default component.exports